import * as Mutations from './mutations';

export const SelectModule = {
    state: {
        selected: [],
        selectedItemDropDown: [],
        selectedId: null
    },

    mutations: {
        [Mutations.TOGGLE_ITEM](state, item) {
            const index = state.selected.findIndex(x => x === item);
            if (index !== -1) {
                state.selected.splice(index, 1);
            }
            else {
                state.selected.push(item);
            }
        },

        [Mutations.TOGGLE_ITEMS](state, items) {
            if (state.selected.length === items.length) {
                state.selected = [];
            }
            else {
                state.selected = [...items];
            }
        },

        [Mutations.RESET_ITEMS](state) {
            state.selected = [];
        },

        [Mutations.TOGGLE_ITEM_DROP_DOWN](state, selectedItemDropDown) {
            state.selectedItemDropDown = selectedItemDropDown;
        },

        [Mutations.RESET_ITEM_DROP_DOWN](state) {
            state.selectedItemDropDown = [];
        },

        [Mutations.SELECTED_ITEM_ID](state, id) {
            state.selectedId = id;
        },

        [Mutations.RESET_ITEM_ID](state) {
            state.selectedId = null;
        }
    },

    actions: {
        toggleItem(context, item) {
            context.commit(Mutations.TOGGLE_ITEM, item);
        },

        toggleItems(context, items) {
            context.commit(Mutations.TOGGLE_ITEMS, items);
        },

        resetSelectedItems(context) {
            context.commit(Mutations.RESET_ITEMS);
        },

        selectedItemFromSelectBox(context, items) {
            context.commit(Mutations.TOGGLE_ITEM_DROP_DOWN, items);
        },

        resetSelectedItemFromSelectBox(context) {
            context.commit(Mutations.RESET_ITEM_DROP_DOWN);
        },

        selectedIdItem(context, id) {
            context.commit(Mutations.SELECTED_ITEM_ID, id);
        },

        resetSelectedIdItem(context) {
            context.commit(Mutations.RESET_ITEM_ID);
        }
    },

    getters: {
        selected: state => state.selected,

        checkedAll: (state, getters, rootState, rootGetters) => Boolean(rootGetters.pagination &&
            state.selected.length >= rootGetters.pagination.numberOfElements && state.selected.length),

        selectedItemDropDown: state => state.selectedItemDropDown,

        selectedId: state => state.selectedId,
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/select/select.module.js